import { initialState } from "./state";

export const mirchiTop20 = (state = initialState, action) => {
  switch (action.type) {
    case "SET_MIRCHITOP20_LIST": {
      return Object.assign({}, state, {
        mirchiTop20List: action.data
      });
    }
    default:
      return state;
  }
};
